import classnames from "classnames";
import React, { useState } from "react";

import { ColorswatchFacetDisplayValue } from "@components/Search/SearchResults/StateComponents/Facets/Facet/components/ColorswatchFacet/colorswatchFacet.container";

type ColorswatchFacetValueComponentProps = {
    value: ColorswatchFacetDisplayValue;
};

const ColorswatchFacetValueComponent = ({
    value,
}: ColorswatchFacetValueComponentProps) => {
    const [isRefinedOptimistic, setIsRefinedOptimistic] = useState<boolean>(
        value.refined,
    );

    const handleOnClick = () => {
        setIsRefinedOptimistic(isChecked => !isChecked);
        value.onRefine();
    };

    return (
        <li>
            <button
                className={classnames(
                    "colorswatch__item cursor-pointer",
                    isRefinedOptimistic && "colorswatch__item--active",
                )}
                onClick={handleOnClick}
            >
                <img title={value.label} src={value.url} alt={value.label} />
            </button>
        </li>
    );
};

export { ColorswatchFacetValueComponent };
